import { useDeleteTimeEntryMutation } from "@common/api/time-entries"
import { currentUserQuery } from "@common/api/users"
import { ConfirmDialog } from "@common/components/shared/confirm-dialog"
import { hasPermission } from "@common/lib/permissions"
import { handleError } from "@common/utils"
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"

export const Route = createFileRoute(
  "/_layout/work-orders/$workOrderId/tasks/$taskId/time-entries/$timeEntryId/delete",
)({
  beforeLoad: async ({ context: { queryClient }, params, search }) => {
    const me = await queryClient.ensureQueryData(currentUserQuery())
    if (!hasPermission(me, "time_entry:record")) {
      throw redirect({
        to: "/work-orders/$workOrderId/tasks/$taskId",
        params,
        search,
      })
    }
  },
  component: DeleteTimeEntryDialog,
})

function DeleteTimeEntryDialog(): React.ReactElement {
  const { workOrderId, taskId, timeEntryId } = Route.useParams()
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const mutation = useDeleteTimeEntryMutation()

  const close = () =>
    navigate({
      to: "/work-orders/$workOrderId/tasks/$taskId",
      params: { workOrderId, taskId },
      search: true,
    })

  return (
    <ConfirmDialog
      title="Archive this time entry?"
      description="Its hours come off the task and your timesheet."
      action="Archive"
      tone="default"
      pendingAction="Archiving…"
      pending={mutation.isPending}
      onCancel={close}
      onConfirm={() =>
        mutation.mutate(
          { time_entry_id: timeEntryId },
          {
            onSuccess: () => {
              showToast("Time entry archived", "", "success")
              close()
            },
            onError: (err) => handleError(err, showToast),
          },
        )
      }
    />
  )
}
